import { Box, Typography } from '@mui/material';
import { FeedbackSuccess, Clock } from '../../assets';
import BaseModal from '../BaseModal/BaseModal';
import * as Styled from '../MatchmakerAttendeeModal/MatchmakerAttendeeModal.styles';
import { Step } from '../../models/matchmakerModel';

type MatchmakerStatusModalProps = {
  open: any;
  onClose: any;
  currentStep: Step
}

const MatchmakerStatusModal = ({
  open,
  onClose,
  currentStep
}: MatchmakerStatusModalProps) => {

  return (
    <>
    {currentStep === Step.SUCCESS ? 
    <BaseModal open={open} onClose={onClose} desktopWidth={"auto"} showCloseButton={true}>
      <Styled.SuccessModalContainer>
        <Box sx={{display: "flex", marginTop: "30px", justifyContent: "center"}}>
          <Styled.SuccessImage src={FeedbackSuccess} alt="success-heart-logo" />
        </Box>
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", rowGap: "10px"}}>
          <Typography variant="h2">Thanks!</Typography>
          <Typography variant="modalBody">We hope you enjoyed Matchmaker!</Typography>
        </Box>
      </Styled.SuccessModalContainer>
    </BaseModal> 
    :
     <BaseModal open={open} onClose={onClose} desktopWidth={"auto"} showCloseButton={true}>
      <Styled.SuccessModalContainer>
        <Box sx={{display: "flex", marginTop: "30px", justifyContent: "center"}}>
          <Styled.SuccessImage src={Clock} alt="timeout-clock-image" />
        </Box>
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", rowGap: "10px"}}>
          <Typography variant="h2">Whoops!</Typography>
          <Typography variant="modalBody">You've timed out of Matchmaker!</Typography>
        </Box>
      </Styled.SuccessModalContainer>
    </BaseModal> }
    </>
  )
}

export default MatchmakerStatusModal;